module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/WizardButton/images/body-texture.e87d6317.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/WizardButton/images/body-texture.png
// module id = 2533
// module chunks = 11